import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, useHistory } from "react-router-dom";
import routes from "./../../config/app-route.js";
import { AppSettings } from "./../../config/app-settings.js";

import ErrorPage from "./../../pages/error/ErrorPage";

function setTitle(path, routeArray) {
    var appTitle;
    for (var i = 0; i < routeArray.length; i++) {
        if (routeArray[i].path === path) {
            appTitle = "Mambo Admin | " + routeArray[i].title;
        }
    }
    document.title = appTitle ? appTitle : "Mambo Admin | React Website";
}

const Content = () => {
    let history = useHistory();
    const session = useSelector((state) => state.session.user);

    useEffect(() => {
        setTitle(history.location.pathname, routes);
        history.listen(() => {
            setTitle(history.location.pathname, routes);
        });
    }, []);

    return (
        <AppSettings.Consumer>
            {({ appContentClass }) => (
                <div className={"app-content " + appContentClass}>
                    {routes.map((route, index) => {
                        if (route.needAdmin) {
                            if (session?.admin) {
                                return <Route key={index} path={route.path} exact={route.exact} component={route.component} />;
                            } else {
                                return (
                                    <Route key={index} path={route.path} exact={route.exact} component={() => <ErrorPage />} />
                                );
                            }
                        } else {
                            return <Route key={index} path={route.path} exact={route.exact} component={route.component} />;
                        }
                    })}
                </div>
            )}
        </AppSettings.Consumer>
    );
};

export default Content;
